import React from 'react';
import PropTypes from 'prop-types';

import urlUtils from 'app/shared/utils/urlUtils';

// Stylesheets
import './style.scss';

const propTypes = {
    templateValues: PropTypes.object.isRequired,
};

// Keep in sync with https://admanager.google.com/7449#creatives/custom_native_style/detail/styleid=270429
const DfpPreviewCustomFlag = ({
    templateValues,
}) => {
    const href = templateValues.destinationUrl ? urlUtils.addProtocol(templateValues.destinationUrl) : '#';
    let { listHeaderText } = templateValues;
    if (templateValues.listHeaderText === 'Custom') {
        listHeaderText = templateValues.textHeaderCustom;
    } else if (templateValues.listHeaderText === '') {
        listHeaderText = 'For Rent';
    }
    return (
        <div className="DfpPreviewCustomFlag">
            <link
                rel="stylesheet"
                media="all"
                href="https://www.zillowstatic.com/static-zsg/LATEST/static-zsg/zsg/z-base/zsg-icons.css"
            />

            <div id={`logo${templateValues.listDisplayLogo}`}>
                <div className="container">
                    <div className="wrapper">
                        <a
                            href={href}
                            target="_blank"
                            rel="noopener noreferrer"
                            id="clickthru"
                        >
                            <div
                                className="brandImage"
                                style={{ backgroundImage: `url(${templateValues.imageBrandRectangle})` }}
                            >
                                <div className="slugOverlay">Sponsored</div>
                                <div className="headerOverlay" id="flagText">{listHeaderText}</div>
                                <div className={`eho-${templateValues.listDisplayEHOImage}`} />
                            </div>
                            <div className="textContent squareSpace">
                                <ul>
                                    <li className="header">{templateValues.textSubheader01}</li>
                                    <li className="subheader">{templateValues.textSubheader02}</li>
                                    <li className="subheader">{templateValues.textSubheader03}</li>
                                    <li className="CTA">
                                        {templateValues.textCTA}
                                        <span className="zsg-icon-pop-up" />
                                    </li>
                                    <li className="logoImage squareSize">
                                        <img
                                            id="logoSrc"
                                            className="squareLogo"
                                            src={templateValues.imageLogo}
                                            alt=""
                                        />
                                    </li>
                                </ul>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};

DfpPreviewCustomFlag.propTypes = propTypes;

export default DfpPreviewCustomFlag;
